const gauss = (n) => n * ((n + 1) / 2)

/**
 * Estimate the number of users ahead of you
 *
 * We assume the number of trees decreases
 * linearly with the number of users:
 *
 *  users |
 *        |__
 *        |__|__
 *        |__|__|___
 *        |__|__|__|___
 *  alpha |__|__|__|__|__
 *        |__|__|__|__|__|____________
 *         0  1  2  3  4         trees
 *
 * alpha = number of users inside one square
 *
 * Then:
 *
 *                      i = maxTrees
 * alpha = totalUsers / sum (maxTrees - i + 1)
 *                      i = 0
 * @param {*} totalUsers
 * @param {*} maxTrees
 * @param {*} myTrees
 */
const getPositionDiff = (totalUsers, maxTrees, myTrees) => {
    const length = gauss(maxTrees + 1)
    const alpha = length > 0 ? Math.floor(totalUsers / length) : 0
    return alpha * gauss(maxTrees - myTrees)
    // ^ Number of users ahead of you
}

export { gauss, getPositionDiff }
